module.exports = __webpack_public_path__ + "static/media/Python-for-CPGE.9c12841b.png";